export default "__VITE_ASSET__bea13730__"